export const temperament = [
  { name: 'Carinhoso', value: 'loving' },
  { name: 'Agressivo', value: 'aggressive' },
  { name: 'Calmo', value: 'calm' },
  { name: 'Enérgico', value: 'energetic' },
  { name: 'Amigável', value: 'friendly' },
  { name: 'Brincalhão', value: 'playful' },
  { name: 'Protetor', value: 'protective' },
  { name: 'Tímido', value: 'shy' },
  { name: 'Curioso', value: 'curious' },
  { name: 'Medroso', value: 'fearful' },
  { name: 'Ingênuo', value: 'ingenuous' }
]

export const genders = [
  { name: 'Macho', value: 'male' },
  { name: 'Fêmea', value: 'female' },
  { name: 'Desconhecido', value: 'unknown' }
]

export const species = [
  { name: 'Cachorro', value: 'dog' },
  { name: 'Gato', value: 'cat' },
  { name: 'Pássaro', value: 'bird' },
  { name: 'Réptil', value: 'reptile' }
]

export interface Pet {
  id?: string,
  userId?: string,
  name: string,
  birthdate: Date,
  gender: string,
  specie: string,
  breed?: string,
  qrcodeId?: string,
  temperament: string[],
  foodType: string,
  files: string[],
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
};
